module.exports = __webpack_public_path__ + "static/media/language-icon.512b5bc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/language-icon.svg
// module id = 346
// module chunks = 0